import { render, staticRenderFns } from "./WorkRegionTableItem.vue?vue&type=template&id=6e047d79&"
import script from "./WorkRegionTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkRegionTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports